import React from "react"
import './Loading.css';

function LoadingPage(props){ 
	const WORDS='載入中......'.split('')
	return(
		<div className='wavybody'>
			<div className='wavy'>
				{WORDS.map((item,index)=><span key={index} style={{'--i':(index+1)}}>{item}</span>)}
			</div>
		</div>
	);
}

export default LoadingPage 